import React from 'react';
import AuthenticatedUserChip from '../../common/AuthenticatedUserChip';
import { useFormPalette } from './DynamicFormPrimitives';

/**
 * Form-specific wrapper around the shared chip.
 *
 * @param {boolean} [inline]
 *   When false (default) the chip is fixed in the top-right corner — the
 *   layout used by a standalone public form that has no sticky topBar.
 *   When true the chip renders in flow (no position/zIndex) so the caller
 *   can slot it into an existing sticky header without overlapping its
 *   contents — used by the FormFlow topBar, which already hosts the flow
 *   brand + stepper on the left side of the same band.
 */
export default function FormAuthenticatedUserChip({ inline = false } = {}) {
  const palette = useFormPalette();
  const sx = inline ? undefined : { position: 'fixed', top: 16, right: 16, zIndex: 100 };

  return <AuthenticatedUserChip palette={palette} sx={sx} />;
}
